module.exports = __webpack_public_path__ + "img/download.9421b16d.svg";